import { render, staticRenderFns } from "./LearningSettingsInvite.vue?vue&type=template&id=37c4b8e0&"
import script from "./LearningSettingsInvite.vue?vue&type=script&lang=js&"
export * from "./LearningSettingsInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports